var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUpload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 43,
    height: 42,
    viewBox: "0 0 43 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2142_60029)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M33.9417 3.12061H14.6743V11.1106H38.0567V7.23402C38.0567 4.96567 36.2107 3.12061 33.9417 3.12061Z",
    fill: "#EAE2FD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.0352 12.3403H0.5V4.92636C0.5 2.20972 2.71068 0 5.42828 0H12.6336C13.3497 0 14.0396 0.150925 14.6664 0.434509C15.5418 0.828964 16.2939 1.47913 16.8213 2.3286L23.0352 12.3403Z",
    fill: "#6720FD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.5 14.0001V37.8815C42.5 40.1527 40.6511 42 38.3789 42H4.62111C2.34891 42 0.5 40.1527 0.5 37.8815V9.88062H38.3789C40.6511 9.88062 42.5 11.7286 42.5 14.0001Z",
    fill: "#7536FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.5 14.0001V37.8815C42.5 40.1527 40.6511 42 38.3789 42H21.5V9.88062H38.3789C40.6511 9.88062 42.5 11.7286 42.5 14.0001Z",
    fill: "#6924FD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.548 25.9398C32.548 32.0322 27.5919 36.9887 21.5001 36.9887C15.4083 36.9887 10.4521 32.0322 10.4521 25.9398C10.4521 19.8483 15.4083 14.8918 21.5001 14.8918C27.5919 14.8918 32.548 19.8483 32.548 25.9398Z",
    fill: "#F3EEFD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.5479 25.9398C32.5479 32.0322 27.5918 36.9887 21.5 36.9887V14.8918C27.5918 14.8918 32.5479 19.8483 32.5479 25.9398Z",
    fill: "#EAE2FD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.061 26.0753C24.8306 26.2704 24.5483 26.3656 24.2685 26.3656C23.9183 26.3656 23.5703 26.2173 23.3268 25.9282L22.7304 25.2213V29.8494C22.7304 30.5287 22.1793 31.0799 21.5 31.0799C20.8207 31.0799 20.2695 30.5287 20.2695 29.8494V25.2213L19.6732 25.9282C19.2342 26.4476 18.4584 26.514 17.939 26.0753C17.4199 25.6373 17.3532 24.8612 17.7913 24.3418L20.2269 21.4543C20.5444 21.0788 21.0078 20.8628 21.5 20.8628C21.9922 20.8628 22.4555 21.0788 22.7731 21.4543L25.2087 24.3418C25.6467 24.8612 25.5801 25.6373 25.061 26.0753Z",
    fill: "#C4A9FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.061 26.0753C24.8306 26.2704 24.5483 26.3656 24.2686 26.3656C23.9183 26.3656 23.5703 26.2173 23.3268 25.9282L22.7305 25.2213V29.8494C22.7305 30.5287 22.1793 31.0799 21.5 31.0799V20.8628C21.9922 20.8628 22.4555 21.0788 22.7731 21.4543L25.2087 24.3418C25.6467 24.8612 25.5801 25.6373 25.061 26.0753Z",
    fill: "#7F43FF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2142_60029"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 42,
    height: 42,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpload);
export default __webpack_public_path__ + "static/media/upload.ce87393e643d176ceb70cfcce95ba577.svg";
export { ForwardRef as ReactComponent };